module.exports = __webpack_public_path__ + "img/H1.4bb7e86b.png";